/**
 * Money formatting — CLAUDE.md domain rule #9: money is always cents (int,
 * BRL) on the wire; conversion to a display currency string happens ONLY at
 * the presentation layer, never upstream.
 */

const BRL_FORMATTER = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });

export function formatCentsToBRL(cents: number): string {
  return BRL_FORMATTER.format(cents / 100);
}
